export const ids = {};

export default function uniqueId(prefix: string) {
  if (!ids[prefix]) {
    ids[prefix] = 0;
  }

  return `${prefix}-${++ids[prefix]}`;
}



// WEBPACK FOOTER //
// ./src/app/utils/uniqueId.ts